/* GLOWIVY store upgrade: bundle status, package protection toggle, cart drawer safety net */
(function () {
  var TIERS = [{ qty: 2, off: 10 }, { qty: 3, off: 15 }, { qty: 5, off: 20 }];
  var PROTECTION_TYPE = 'Package Protection';

  function eligibleCount(cart) {
    return (cart.items || []).reduce(function (n, i) {
      return i.product_type === PROTECTION_TYPE ? n : n + i.quantity;
    }, 0);
  }

  function updateBundle(cart) {
    var count = eligibleCount(cart);
    document.querySelectorAll('[data-gv-bundle]').forEach(function (el) {
      var active = null;
      TIERS.forEach(function (t) { if (count >= t.qty) active = t; });
      el.querySelectorAll('.gv-bundle__card').forEach(function (c) {
        c.classList.toggle('is-active', !!active && parseInt(c.getAttribute('data-tier'), 10) === active.qty);
      });
      var next = TIERS.filter(function (t) { return count < t.qty; })[0];
      var status = el.querySelector('[data-gv-bundle-status]');
      if (!status) return;
      if (!next) {
        status.innerHTML = 'You’re getting the best deal: <strong>20% off</strong> in your cart.';
      } else if (count === 0) {
        status.innerHTML = 'Mix &amp; match any items. Discount applies automatically in your cart.';
      } else {
        var left = next.qty - count;
        status.innerHTML = 'Add ' + left + ' more item' + (left > 1 ? 's' : '') + ' for <strong>' + next.off + '% off</strong>.';
      }
    });
  }

  function refreshBundle() {
    if (!document.querySelector('[data-gv-bundle]')) return;
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(updateBundle)
      .catch(function () {});
  }

  function rerenderDrawer(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
      drawer.renderContents(state);
    }
    refreshBundle();
  }

  function fetchDrawerSections() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) { return { sections: sections }; });
  }

  // Package protection checkbox
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-gv-protection]');
    if (!input) return;
    var label = input.closest('.gv-protection');
    if (label) label.classList.add('is-loading');
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    var req;
    if (input.checked) {
      req = fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(input.getAttribute('data-variant-id'), 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
      });
    } else {
      req = fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: input.getAttribute('data-line-key'), quantity: 0, sections: 'cart-drawer,cart-icon-bubble' })
      });
    }
    req.then(function (r) { return r.json(); })
      .then(function (state) { if (state.sections) { rerenderDrawer(state); } else { return fetchDrawerSections().then(rerenderDrawer); } })
      .catch(function () { if (label) label.classList.remove('is-loading'); });
  });

  // Safety net: always open the cart drawer after Add to cart
  function openDrawerIfClosed() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.classList.contains('active')) return;
    fetchDrawerSections().then(rerenderDrawer).catch(function () { drawer.open && drawer.open(); });
  }

  function hookPubSub() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        refreshBundle();
        if (event && event.source === 'product-form') setTimeout(openDrawerIfClosed, 900);
      });
      return true;
    }
    return false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!hookPubSub()) setTimeout(hookPubSub, 1000);
    refreshBundle();
  });
})();
